import ToastUtils from '@hotmart/cosmos/dist/toast/utils'

import type { ToastDetailTypes } from './types'

import { EventsName } from '../constants'

const toastEventDispatch = (toastDetail: ToastDetailTypes) => {
  const toastEvent = new CustomEvent(EventsName.TOAST, {
    detail: toastDetail
  })

  window.dispatchEvent(toastEvent)
}

const toaster = (event: Event) => {
  const { detail } = event as CustomEvent<ToastDetailTypes>
  const { type, message, position = 'top right' } = detail

  ToastUtils[type]({ message, position })
}

const toastEventListener = () => {
  window.addEventListener(EventsName.TOAST, toaster)

  return () => window.removeEventListener(EventsName.TOAST, toaster)
}

export { toastEventDispatch, toastEventListener }
